import {Component} from '@angular/core';
import {DELIVERY_EXPENSES, DELIVERY_TIME_TEXT, FREE_DELIVERY_THRESHOLD} from "../../services/util/constants";

interface TrustPoint {
    /** An image file, or an outline icon path drawn inline (24x24, stroke). */
    icon?: string;
    path?: string;
    title: string;
    text: string;
    href?: string;
}

/**
 * What a first-time buyer wants to know before trusting an unknown shop, near the top of the
 * home page: when they pay, how fast it arrives, whether it is genuine, who answers.
 */
@Component({
    selector: 'app-trust-strip',
    standalone: true,
    template: `
        <section class="px-3 pb-6 lg:pb-10 max-w-6xl mx-auto" aria-label="Зошто да купите кај нас">
            <ul class="grid grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-4 list-none p-0 m-0">
                @for (point of points; track point.title) {
                    <li class="flex items-start gap-2 lg:gap-3 rounded-lg bg-green-50 border border-green-100 p-3 lg:p-4 text-left">
                        @if (point.path) {
                            <svg class="w-7 h-7 lg:w-9 lg:h-9 shrink-0 text-gray-800" viewBox="0 0 24 24" fill="none"
                                 stroke="currentColor" stroke-width="1.5" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="point.path"/>
                            </svg>
                        } @else {
                            <img class="w-7 h-7 lg:w-9 lg:h-9 shrink-0" [src]="point.icon" alt="" width="36" height="36">
                        }
                        <div class="min-w-0">
                            <p class="text-sm lg:text-base font-semibold text-gray-900 leading-tight">{{ point.title }}</p>
                            @if (point.href) {
                                <a class="block text-xs lg:text-sm text-primaryDark underline" [href]="point.href">{{ point.text }}</a>
                            } @else {
                                <p class="text-xs lg:text-sm text-gray-700">{{ point.text }}</p>
                            }
                        </div>
                    </li>
                }
            </ul>
        </section>
    `
})
export class TrustStripComponent {

    readonly points: TrustPoint[] = [
        {
            icon: '/assets/icons/cash-on-delivery.svg',
            title: 'Плаќање при достава',
            text: 'Во готово, кога ќе ја примите пратката.'
        },
        {
            icon: '/assets/icons/delivery-truck.svg',
            title: `Достава за ${DELIVERY_TIME_TEXT}`,
            text: `${DELIVERY_EXPENSES} ден., бесплатна над ${FREE_DELIVERY_THRESHOLD} ден.`
        },
        {
            // shield with a check mark
            path: 'M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z',
            title: 'Оригинални производи',
            text: 'Forever Living, во оригинално пакување.'
        },
        {
            // phone handset
            path: 'M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z',
            title: 'Совет пред нарачка',
            text: '073/857-133, и на Viber',
            href: 'tel:+38973857133'
        }
    ];
}
